export default {
  "Pokaż odrzucone": "Show rejected",
  "Pokaż z kuponem": "Show orders with coupons",
  "Nazwa klienta": "Clients name",
  "Wyszukaj po kliencie": "Search by client",
  "Email": "Email",
  "Miasto": "City",
  "Wyszukaj po mieście": "Search by city",
  "Numer telefonu": "Phone no.",
  "Wyszukaj po numerze telefonu": "Search by phone no.",
  "Wyszukaj po emailu": "Search by email",
  "Numer zamówienia": "Order id",
  "Wyszukaj po numerze zamówienia": "Search by order id",
  "Kupony": "Coupons",
  "Wyszukaj po kuponie": "Search by coupon",
  "Wyszukaj": "Search",
  "Status": "Status",
  "Brak kuponu": "No coupon",
  "Komentarz został dodany.": "Note has been added.",
  "Dodaj notatkę": "Add note",
  "Faktura": "Invoice",
  "Brak zwrotu": "Not returned",
  "Data złożenia zamówienia": "Order return's date",
  "Data dostarczenia zamówienia": "Order delivery date",
  "Brak faktury": "No invoice",
  "Data dostarczenia zamówienia na magazyn": "Date of appearing order in warehouse's system",
  "Nowe / czeka": "New",
  "Magazynier kompletuje zamówienie": "Collecting started",
  "Zamówienie skompletowane / przekazane do wysyłki": "Collecting ended",
  "Drukowanie listów przewozowych, pakowanie": "Packing",
  "Wysłane": "Sent",
  "Oznaczone jako niemożliwe do zrealizowania": "Unable to send",
  "Zamówienie wyciągane z sortowni do wysyłki": "Collecting from sorting departament",
  "Zamówienie zostało anulowane": "Canceled",
  "Zamówienie spakowane. List przewozowy naklejony i przypisany do zamówienia": "Packed",
  "Zamówienie nowe, niezapłacone, oczekiwanie na PayU": "New, no payment",
  "Zamówienie nie zostało opłacone, przeterminowane": "Payment overdue",
  "Niedopłata": "Underpaid",
  "Nadpłata": "Overpaid",
  "Zapłacono": "Paid",
  "Numer paczkomatu": "Post machine no.",
  "Numer POP": "Post point no.",
  "Sposób płatności": "Payment method",
};



// WEBPACK FOOTER //
// ./locales/en_US/orders.js